import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";
import {
    DKLabel,
    DKButton,
    DKInput,
    DKCheckMark,
    DKTooltipWrapper,
    DKIcon,
    DKIcons,
    DKSpinner,
    Toggle,
    INPUT_TYPE,
    INPUT_VIEW_DIRECTION,
    showLoader,
    removeLoader,
    showToast,
    TOAST_TYPE
} from "deskera-ui-library";
import { TENANT, TenantService } from "../../../managers/TenantManagerService";
import TimesheetService from "../TimesheetService";
import DKInputDateTime from "../../common/DKInputDateTime";
import moment from 'moment';
import TimesheetUtils from "../TimesheetUtils";
import { ENTRY_STATUS } from "../TimesheetConstants";
import { convertDateToJson, reverseTimezoneOffset } from "../../../managers/common/CommonUtil";
import { WEEK_DAYS } from "../../../constants/Constant";
import Utility from "../../../utility/Utility";

function MoreEntriesPopup(props) {
    const { t } = useTranslation();

    useEffect(() => {
        return removeElement;
    }, []);

    const removeElement = () => {
        if (props.elementId) {
            const element = document.getElementById(props.elementId);
            if (element) {
                ReactDOM.unmountComponentAtNode(element);
                element.remove();
            }
        }
    }

    const renderEntry = (entry) => {
        return (
            <div onClick={(e) => { e.stopPropagation(); props?.onShowEntry(entry); }}>
                <div className="d-flex mr-m p-v-xs p-h-s mb-s bg-gray2 border-radius-s cursor-hand">
                    <span className="ellipsis" style={{ maxWidth: "110px", minWidth: "110px" }}>
                        &#9679;&nbsp;{entry.jobName}
                    </span>
                    <span className="ellipsis text-align-right" style={{ maxWidth: "60px", minWidth: "60px" }}>
                        {!Utility.isEmpty(entry.toDate) ? TimesheetUtils.getTimeInString(entry.seconds) : "-"}
                    </span>
                </div>
            </div>
        );
    }

    return (
        <div className="transparent-background">
            <div className="popup-window" style={{ padding: 0, overflow: "hidden", width: "250px", maxWidth: "250px" }}>
                <div className="parent-width" style={{ height: "250px", maxHeight: "60vh" }}>
                    <div className="row p-h-xl pt-xl pb-m">
                        <DKLabel text={props?.entryDate ? moment(props.entryDate).format("ddd, Do MMM") : ""} className="fs-l fw-b" />
                        <div className="ml-auto d-flex">
                            <DKIcon
                                src={DKIcons.ic_close}
                                className="ic-s"
                                onClick={() => {
                                    removeElement();
                                }}
                            />
                        </div>
                    </div>
                    <div className="parent-width custom-scroll" style={{ overflow: "auto", height: "calc(100% - 69px)" }}>
                        <div className="p-h-xl p-v-m">
                            {props?.entries?.map((entry) => renderEntry(entry))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MoreEntriesPopup;
